import { Component, Input, EventEmitter } from '@angular/core';

import { isNullOrUndefined } from '@uzurv/core';
import { GenericListSlideToggleClickHandlerData } from './generic-list-slide-toggle-click-handler-data';

@Component({
  selector: 'app-generic-list-slide-toggle',
  templateUrl: './generic-list-slide-toggle.component.html',
  styleUrls: ['./generic-list-slide-toggle.component.scss']
})
export class GenericListSlideToggleComponent {
  @Input() label: string;

  @Input() state = false;

  @Input() disabled = false;

  @Input() color = 'primary';

  @Input() classes: string;

  @Input() clickHandler: EventEmitter<GenericListSlideToggleClickHandlerData>;

  @Input() data: any;

  constructor() {}

  updateState(event): void {
    if (!isNullOrUndefined(this.clickHandler)) {
      this.clickHandler.emit({ data: this.data, value: event });
    }
  }
}
